<template>
  <div>
    <div
      ref="bienvenidaRef"
      class="bienvenida-container"
    >
      <div class="mensaje-container">
        <h2>Libro de Firmas:</h2>
        <textarea
          v-model="nuevoMensaje"
          placeholder="Tu mensaje aquí..."
          rows="4"
          maxlength="500"
          @input="verificarLongitud"
        />
        <div class="contador">
          {{ caracteresRestantes }} caracteres restantes
        </div>

        <input
          v-model="localNombre"
          type="text"
          placeholder="Tu nombre aquí..."
          class="nombre-input"
        >
        <button @click="enviarMensaje">
          Enviar
        </button>

        <div class="mensajes-enviados">
          <h3>Mensajes recibidos:</h3>
          <div
            v-for="(mensajeObj, index) in mensajes"
            :key="index"
            class="mensaje-tarjeta"
          >
            <strong>{{ mensajeObj.nombre }}:</strong> {{ mensajeObj.mensaje }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick, computed } from 'vue';
import axios from 'axios';
import baseUrl from '@/api';  // Asegúrate de importar la URL base


export default {
  name: 'BienvenidaPage',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const nuevoMensaje = ref('');
    const localNombre = ref('');
    const mensajes = ref([]);
    const animationDone = ref(false);
    const maxCaracteres = 500; // Cambia este número según tus necesidades
    const caracteresRestantes = computed(() => maxCaracteres - nuevoMensaje.value.length);
  
    const verificarLongitud = () => {
      if (nuevoMensaje.value.length > 500) {
        nuevoMensaje.value = nuevoMensaje.value.slice(0, 500);
      }
    };
    // Función para obtener mensajes al montar el componente
    const obtenerMensajes = async () => {
      try {
        const response = await axios.get(`${baseUrl}/mensajes?idFestejado=${props.idFestejado}`);
        mensajes.value = response.data; // Asume que la respuesta es un array de objetos con nombre y mensaje
      } catch (error) {
        console.error('Error al obtener los mensajes:', error);
      }
    };

    const enviarMensaje = async () => {
      if (nuevoMensaje.value.trim() && localNombre.value.trim()) {
        console.log('Datos a enviar:', {
          mensaje: nuevoMensaje.value.trim(),
          idFestejado: props.idFestejado,
          idInvitado: props.idInvitado,
          nombre: localNombre.value.trim(),
        });

        try {
  const response = await axios.post(`${baseUrl}/mensajes`, {
    mensaje: nuevoMensaje.value.trim(),
    idFestejado: props.idFestejado,
    idInvitado: props.idInvitado,
    nombre: localNombre.value.trim(),
  });
          console.log(response.data); // Mensaje de éxito
          
          // Agregar el mensaje como objeto
          mensajes.value.push({
            nombre: localNombre.value.trim(),
            mensaje: nuevoMensaje.value.trim()
          });

          nuevoMensaje.value = '';
          localNombre.value = '';
        } catch (error) {
          console.error('Error al guardar el mensaje:', error);
        }
      }
    };

    onMounted(async () => {
      await obtenerMensajes(); // Llamar a la función para obtener mensajes
      await nextTick();
      if (bienvenidaRef.value) {
        const element = bienvenidaRef.value;

        const observerOptions = {
          root: null,
          rootMargin: '0px',
          threshold: [0.1],
        };

        const observerCallback = (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!animationDone.value) {
                element.classList.add('animate__animated', 'animate__fadeInUp');
                element.addEventListener('animationend', () => {
                  element.classList.remove('animate__animated', 'animate__fadeInUp');
                  element.style.opacity = '1';
                }, { once: true });

                animationDone.value = true;
              }
            } else {
              element.style.opacity = '0';
              animationDone.value = false;
            }
          });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(element);
      }
    });

    return { bienvenidaRef, nuevoMensaje, localNombre, mensajes, enviarMensaje,caracteresRestantes,verificarLongitud };
  },
};
</script><style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400&family=Poppins:wght@400;500;600;700&display=swap');

/* CONTENEDOR MENSAJE DE BIENVENIDA CON TEXTURA Y MARCO ELEGANTE */
.bienvenida-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  padding: 40px 24px;
  background-color: #f5f0e6;
    margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  border: 1.5px solid #cba56b;
  box-shadow: 0 10px 25px rgba(73, 121, 160, 0.12);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.bienvenida-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(73, 121, 160, 0.18);
}

.mensaje-bienvenida {
  font-size: 1.85rem !important;
  font-weight: 700;
  font-family: 'Cinzel', 'Playfair Display', serif;
  color: #4979a0;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 10px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.08));
}

/* CONTENEDOR DEL ÍCONO */
.icono-container {
  margin: 15px 0;
}

.icono {
  font-size: 28px;
  color: #cba56b;
  opacity: 0.95;
  animation: pulsar 2s infinite ease-in-out;
}

@keyframes pulsar {
  0% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.1); opacity: 1; filter: drop-shadow(0 0 6px rgba(203, 165, 107, 0.4)); }
  100% { transform: scale(1); opacity: 0.85; }
}

.texto-adicional {
  font-size: 1rem;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #4979a0;
  margin-top: 10px;
  line-height: 1.6;
}

/* FORMULARIO DE MENSAJES */
.mensaje-container {
  width: 100%;
  max-width: 600px;
  margin-top: 30px;
  padding: 30px 24px;
  border-radius: 20px;
  background: #fff;
  border: 1.5px solid #cba56b;
  box-shadow: 0 10px 25px rgba(73, 121, 160, 0.12);
  backdrop-filter: blur(6px);
  box-sizing: border-box;
}

.mensaje-container h2 {
  font-size: 1.5rem !important;
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-weight: 700;
  color: #4979a0;
  margin-bottom: 20px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;
}

/* INPUTS Y TEXTAREA CON ESTILO EDITORIAL */
.mensaje-container textarea,
.nombre-input {
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1.5px solid #cba56b;
  border-radius: 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  color: #4979a0;
  background-color: rgba(255, 255, 255, 0.85);
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.mensaje-container textarea:focus,
.nombre-input:focus {
  border-color: #4979a0;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(73, 121, 160, 0.2);
  outline: none;
}

/* BOTÓN DE ENVÍO CELESTE Y BORDE DORADO */
.mensaje-container button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f7fc 100%);
  color: #4979a0;
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  border: 1.5px solid #cba56b;
  border-radius: 25px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(73, 121, 160, 0.15);
  transition: all 0.35s ease;
}

.mensaje-container button:hover {
  background: #ffffff;
  transform: translateY(-2px);
  box-shadow: 
    0 6px 18px rgba(73, 121, 160, 0.25),
    0 0 12px rgba(203, 165, 107, 0.3);
}

/* CONTADOR DE CARACTERES */
.contador {
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  color: #4979a0;
  opacity: 0.8;
  text-align: right;
  margin-top: -10px;
  margin-bottom: 15px;
}

/* MENSAJES ENVIADOS (LISTADO) */
.mensajes-enviados {
  width: 100%;
  max-width: 600px;
  margin-top: 30px;
  text-align: left;
}

.mensajes-enviados h3 {
  font-size: 1.1rem;
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-weight: 700;
  color: #4979a0;
  border-left: 4px solid #cba56b;
  padding-left: 12px;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* TARJETA DE MENSAJE INDIVIDUAL */
.mensaje-tarjeta {
  padding: 16px 20px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(203, 165, 107, 0.3);
  border-left: 4px solid #cba56b;
  box-shadow: 0 4px 12px rgba(73, 121, 160, 0.08);
  transition: all 0.3s ease;
}

.mensaje-tarjeta:hover {
  border-left-color: #4979a0;
  transform: translateX(4px);
  background: #ffffff;
  box-shadow: 0 6px 15px rgba(73, 121, 160, 0.12);
}

.mensaje-tarjeta p {
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  color: #4979a0;
  line-height: 1.6;
  margin: 0;
}

.mensaje-tarjeta .autor {
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  color: #cba56b;
  margin-top: 8px;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}

@media (max-width: 576px) {
  .bienvenida-container,
  .mensaje-container {
    padding: 24px 16px;
  }
  
  .mensaje-bienvenida {
    font-size: 1.45rem !important;
  }
}
</style>